export default function FullPageLayout({ children }) {
  return <div className="w-screen h-screen overflow-hidden">{children}</div>;
}
